export enum enumChariotAlarmInput {
    Disabled = 0,
    FlowA = 1,
    FlowTotal = 2,
    Pressure1Latest = 3,
    AnalogueCLatest = 3,
    Pressure2Latest = 7,
    AnalogueDLatest = 7,
    AnalogueELatest = 8,
    FlowB = 9,
    FlowBTotal = 10,
    Pressure1Diff = 11,
    AnalogueCDiff = 11,
    Pressure2Diff = 12,
    AnalogueDDiff = 12,
    AnalogueEDiff = 13,
    ChannelCompare = 20,
    Consumption = 21,       //AQGD-858
    ConsumptionB = 22,
    SignalStrength = 30,
    Battery = 31
}